import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';

i18n
  // Load translation using http backend from /public/locales
  .use(Backend)
  // Detect user language
  .use(LanguageDetector)
  // Pass the i18n instance to react-i18next
  .use(initReactI18next)
  // Initialize i18next
  .init({
    // Fallback language
    fallbackLng: 'en',

    // Don't set a default language - let the detector decide
    // lng: 'en', // Removed this line to allow detection

    // Supported languages
    supportedLngs: ['en', 'es'],

    // Non-explicit supported languages (for language variants like es-MX, es-ES, etc.)
    nonExplicitSupportedLngs: true,

    // Debug mode enabled to see what's happening
    debug: false,

    // Interpolation options
    interpolation: {
      escapeValue: false, // React already escapes values
    },

    // Default namespace
    defaultNS: 'common',

    // Load these namespaces by default
    ns: ['common'],

    // Fallback namespace
    fallbackNS: 'common',

    // Namespace separator
    nsSeparator: ':',

    // Key separator
    keySeparator: '.',

    // Backend options for loading translations from server
    backend: {
      loadPath:
        '/locales/{{lng}}/{{ns}}.json?v=' +
        Math.random().toString(36).substring(7),
    },

    // Language detection options
    detection: {
      // Order of language detection methods
      order: ['navigator', 'localStorage', 'htmlTag', 'path', 'subdomain'],

      // Look for languages in these places
      lookupFromPathIndex: 0,
      lookupFromSubdomainIndex: 0,

      // Cache user language (but don't interfere with auth flows)
      caches: ['localStorage'],

      // localStorage key
      lookupLocalStorage: 'i18nextLng',

      // Check for these language codes in navigator.language
      checkWhitelist: true,

      // Don't cache language during authentication callbacks
      cacheUserLanguage: function (lng, options) {
        // Skip caching during auth callback to prevent localStorage conflicts
        if (
          window.location.pathname.includes('/callback') ||
          window.location.pathname.includes('/login') ||
          window.location.hash.includes('access_token') ||
          window.location.hash.includes('id_token') ||
          window.location.hash.includes('error') ||
          window.location.hash.includes('state')
        ) {
          return;
        }
        if (options.caches && lng) {
          options.caches.forEach(function (c) {
            if (c === 'localStorage' && window.localStorage) {
              window.localStorage.setItem('i18nextLng', lng);
            }
          });
        }
      },

      // Convert language codes (e.g., es-MX -> es)
      convertDetectedLanguage: (lng) => {
        // Convert any Spanish variant to 'es'
        if (lng.startsWith('es')) {
          return 'es';
        }
        // Convert any English variant to 'en'
        if (lng.startsWith('en')) {
          return 'en';
        }
        return lng;
      },
    },
  })
  .then((t) => {
    // Force reload of resources to bypass any caching
    i18n.reloadResources();
    // Language preference will be preserved in localStorage
    return t;
  })
  .catch((err) => {
    console.error('i18n initialization failed:', err);
  });

export default i18n;
